import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'header-badge',
  styleUrl: 'header-badge.scss',
  shadow: true
})
export class HeaderBadge {
  /**
   * If true, badge will blink.
   */
  @Prop({ reflect: true }) blink: boolean = false;
  @Prop() class?: string;

  render() {
    const customClasses = this.class?.split(' ').reduce((acc, className) => {
      acc[className] = true;
      return acc;
    }, {} as Record<string, boolean>);
    return (
      <Host>
        <div
          class={{
            'header-badge': true,
            'blinking': this.blink,
            ...customClasses
          }}
        >
          <slot />
        </div>
      </Host>
    );
  }
}
